import React from "react";
import { SeverityChip, StatusChip, TeamChip, fmtRel } from "./shared";

export const IncidentRow = ({ incident, selected, onSelect }) => {
  return (
    <button
      onClick={() => onSelect?.(incident)}
      data-testid={`incident-row-${incident.id}`}
      className={[
        "w-full text-left px-3 py-2 border-b border-border transition-colors block",
        selected
          ? "bg-[hsl(var(--surface-elevated))] border-l-2 !border-l-[hsl(var(--primary))]"
          : "border-l-2 !border-l-transparent hover:bg-[hsl(var(--surface-elevated))]",
      ].join(" ")}
    >
      <div className="flex items-center gap-2 mb-1">
        <SeverityChip sev={incident.severity} />
        <StatusChip status={incident.status} />
        {incident.false_positive && (
          <span className="px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-widest border border-[hsl(var(--muted-foreground))] text-muted-foreground">
            False+
          </span>
        )}
        <span className="ml-auto font-mono text-[10px] text-muted-foreground">
          {fmtRel(incident.created_at)}
        </span>
      </div>
      <div className="font-display font-bold text-xs uppercase tracking-tight leading-tight line-clamp-1">
        {incident.title}
      </div>
      <div className="flex items-center gap-2 mt-1 font-mono text-[10px] text-muted-foreground">
        <span>{incident.camera_id ?? "—"}</span>
        <span>·</span>
        <span className="truncate">{incident.zone_name}</span>
        <span>·</span>
        <span className="truncate">{incident.assignee ?? "Unassigned"}</span>
        <span className="ml-auto"><TeamChip team={incident.team_type} /></span>
      </div>
    </button>
  );
};

export default IncidentRow;
